import { string } from 'yup';

// Min 12 Characters, One Uppercase, One Lowercase, One Number, One special Character
const passwordRegExp =
  // eslint-disable-next-line
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-~!@#$%^&*?()+=_{}|'"`:;<>\/\\.,\[\]])[-~!@#$%^&*?()+=_{}|'"`:;<>\/\\.,\[\]A-Za-z\d]{12,}$/;

export const errors = {
  password:
    'Must Contain 12 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character',
  phone: 'Only numbers and `+` symbol are allowed',
};

export const password = string()
  .required('Field is required')
  .matches(passwordRegExp, errors.password)
  .max(100, 'Max - 100 characters');

export const phoneNumber = string()
  .nullable()
  .test({
    name: 'phoneNumberFormat',
    message: 'Invalid phone number',
    test: (value, context) => {
      if (!value) {
        return true;
      }

      const countryData = context.parent[`${context.path.split('.').reverse()[0]}_countryData`];

      if (!countryData) {
        return true;
      }

      if (context.schema.spec.presence === 'optional' && value === countryData.dialCode) {
        return true;
      }

      return value.length === Array.from(countryData.format).filter(x => x === '.').length;
    },
  });
